import React from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { FiBell } from "react-icons/fi";
import { FaClock } from "react-icons/fa";
import { Crisp } from "crisp-sdk-web";
import "./mobileTopBar.css";

const MobileTopBar = ({ onNewReservation, onNotifications, unreadCount }) => {
  const handleNewReservation = () => {
    if (onNewReservation) {
      onNewReservation();
      return;
    }
    // Fallback: trigger existing open-sidebar-button
    const btn = document.querySelector(".open-sidebar-button");
    if (btn) btn.click();
  };

  const handleOpenBlockedSlots = () => {
    // Temporarily show and click the hidden blocked-slots button
    const btn = document.querySelector(".blocked-slots-manage-button");
    if (btn) {
      const prev = btn.style.display;
      btn.style.display = "flex";
      btn.click();
      setTimeout(() => { btn.style.display = prev; }, 100);
    }
  };

  const handleOpenCrisp = () => {
    // Show the Crisp widget (was hidden on mobile), then open chatbox
    try {
      Crisp.chat.show();
      Crisp.chat.open();
    } catch (e) {
      // Fallback to raw API
      if (window.$crisp) {
        window.$crisp.push(["do", "chat:show"]);
        window.$crisp.push(["do", "chat:open"]);
      }
    }
  };

  const handleNotifications = () => {
    if (onNotifications) onNotifications();
  };

  return (
    <div className="mobile-top-bar">
      <div className="mobile-top-bar__left">
        <span className="mobile-top-bar__title">HappyChef</span>
      </div>
      <div className="mobile-top-bar__actions">
        <button
          className="mobile-top-bar__btn mobile-top-bar__btn--primary"
          onClick={handleNewReservation}
          aria-label="New reservation"
        >
          <AiOutlinePlus size={18} />
        </button>
        <button
          className="mobile-top-bar__btn mobile-top-bar__btn--slots"
          onClick={handleOpenBlockedSlots}
          aria-label="Blocked slots"
        >
          <FaClock size={16} />
        </button>
        <button
          className="mobile-top-bar__btn mobile-top-bar__btn--chat"
          onClick={handleOpenCrisp}
          aria-label="Chat"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
          </svg>
        </button>
        <button
          className="mobile-top-bar__btn mobile-top-bar__btn--bell"
          onClick={handleNotifications}
          aria-label="Notifications"
        >
          <FiBell size={16} />
          {unreadCount > 0 && (
            <span className="mobile-top-bar__badge">
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default MobileTopBar;
